/**
 * ตารางรหัสธนาคาร 3 หลักตามมาตรฐาน ธปท. (BOT bank code)
 * ใช้สองอย่าง
 *   1. ยืนยันว่า value ใน TLV ที่เป็นเลข 3 หลัก คือรหัสธนาคารจริง ไม่ใช่เลขอื่นที่บังเอิญ 3 หลัก
 *   2. แปลงเป็นชื่อย่อสำหรับรายงาน (ไม่ได้เขียนลงฐานข้อมูล — DB เก็บเฉพาะ `qr_bank_code`)
 *
 * ค่าที่คืนลง `receipts.qr_bank_code` คือรหัส 3 หลักตรงตัว ไม่ใช่ชื่อย่อ
 */
export const BOT_BANK_CODES: Readonly<Record<string, string>> = Object.freeze({
  "002": "BBL",
  "004": "KBANK",
  "005": "BOA",
  "006": "KTB",
  "008": "JPMORGAN",
  "011": "TTB",
  "014": "SCB",
  "017": "CITI",
  "018": "SMBC",
  "020": "SCBT",
  "022": "CIMBT",
  "024": "UOBT",
  "025": "BAY",
  "030": "GSB",
  "031": "HSBC",
  "032": "DEUTSCHE",
  "033": "GHB",
  "034": "BAAC",
  "035": "EXIM",
  "039": "MIZUHO",
  "045": "BNPP",
  "052": "ANZ",
  "066": "ISBT",
  "067": "TISCO",
  "069": "KKP",
  "070": "ICBCT",
  "071": "TCD",
  "073": "LHFG",
  "080": "SCBT",
  "098": "SME",
});

export function isBotBankCode(v: string): boolean {
  return Object.prototype.hasOwnProperty.call(BOT_BANK_CODES, v);
}

export function bankShortName(code: string | null): string {
  if (!code) return "-";
  return BOT_BANK_CODES[code] ?? code;
}

/**
 * โฮสต์ในลิงก์ตรวจสลิปที่พบบนสลิปจริง → รหัสธนาคาร
 * เติมเพิ่มเมื่อเจอสลิปธนาคารใหม่ และต้องบันทึกหลักฐานลง FORMATS.md ทุกครั้ง
 */
export const HOST_TO_BANK: Readonly<Record<string, string>> = Object.freeze({
  "www.scb.co.th": "014",
  "scb.co.th": "014",
  "verify.scb.co.th": "014",
  "www.kasikornbank.com": "004",
  "kasikornbank.com": "004",
  "km.kasikornbank.com": "004",
  "www.ktb.co.th": "006",
  "ktb.co.th": "006",
  "www.bangkokbank.com": "002",
  "bangkokbank.com": "002",
  "www.ttbbank.com": "011",
  "ttbbank.com": "011",
  "www.krungsri.com": "025",
  "krungsri.com": "025",
  "www.gsb.or.th": "030",
  "gsb.or.th": "030",
  "www.baac.or.th": "034",
  "baac.or.th": "034",
  "www.ghbank.co.th": "033",
  "ghbank.co.th": "033",
  "promptpay.io": "",
});

/**
 * Application Identifier (AID) ที่พบใน TLV tag 29/30 ของ QR ตระกูล PromptPay
 * ไม่ได้บอกธนาคารผู้โอน แต่ช่วยยืนยันว่าเป็น QR ตระกูลไหน
 */
export const KNOWN_AIDS: Readonly<Record<string, string>> = Object.freeze({
  A000000677010111: "promptpay-credit-transfer",
  A000000677010112: "promptpay-bill-payment",
  A000000677010113: "promptpay-tag30",
  A000000677012006: "promptpay-slip-verify",
});
